import { all, takeLatest } from 'redux-saga/effects';

import { savedViewsCampaignsSagas } from '@redux/reducers/saved_views/campaigns/campaignsReducer';
import { savedViewsCompaniesSagas } from '@redux/reducers/saved_views/companies/companiesReducer';
import { savedViewsContactsSagas } from '@redux/reducers/saved_views/contacts/contactsReducer';
import { savedViewsDisposalsSagas } from '@redux/reducers/saved_views/disposals/disposalsReducer';
import { savedViewViewingsInsightsSagas } from '@redux/reducers/saved_views/insights/savedViewViewingsInsightsReducer';
import { savedViewSocietyDisposalInsightsSagas } from '@redux/reducers/saved_views/society-insights/savedViewSocietyDisposalInsightsReducer';

function* savedViewSaga() {
  for (const [actionType, saga] of savedViewSocietyDisposalInsightsSagas) {
    yield all([takeLatest(actionType, saga)]);
  }

  for (const [actionType, saga] of savedViewViewingsInsightsSagas) {
    yield all([takeLatest(actionType, saga)]);
  }

  for (const [actionType, saga] of savedViewsDisposalsSagas) {
    yield all([takeLatest(actionType, saga)]);
  }

  for (const [actionType, saga] of savedViewsContactsSagas) {
    yield all([takeLatest(actionType, saga)]);
  }

  for (const [actionType, saga] of savedViewsCompaniesSagas) {
    yield all([takeLatest(actionType, saga)]);
  }

  for (const [actionType, saga] of savedViewsCampaignsSagas) {
    yield all([takeLatest(actionType, saga)]);
  }
}

export default savedViewSaga;
